import { useEffect } from "react";
function useOnClickOutside({ ref, ignoreRefs = [], isActive, handler, dep, }) {
    useEffect(() => {
        const listener = (event) => {
            const el = (ref === null || ref === void 0 ? void 0 : ref.current) ? ref.current : ref;
            // Do nothing if clicking ref's element or descendent elements
            if (!el ||
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                el.contains(event.target) ||
                ignoreRefs.find(ignoreRef => 
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                ignoreRef.contains(event.target)) ||
                !isActive) {
                return;
            }
            handler === null || handler === void 0 ? void 0 : handler(event);
        };
        document.addEventListener(`mousedown`, listener);
        document.addEventListener(`touchstart`, listener);
        return () => {
            document.removeEventListener(`mousedown`, listener);
            document.removeEventListener(`touchstart`, listener);
        };
        // Reload only if ref or handler changes
    }, [ref, handler, isActive, ignoreRefs, ...dep]);
}
export default useOnClickOutside;
